import { render, staticRenderFns } from "./WorkshopFileEducatorTable.vue?vue&type=template&id=ad59a614"
import script from "./WorkshopFileEducatorTable.vue?vue&type=script&lang=ts"
export * from "./WorkshopFileEducatorTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports